import './src/components/style/globalReset.css';

import React from 'react';
import Cookies from 'js-cookie';
import { ThemeProvider } from 'styled-components';
import type { WrapPageElementBrowserArgs, WrapRootElementBrowserArgs } from 'gatsby';

import { initChannelIO } from './src/hooks/useChannelIO';
import { hydrateAppStore } from './src/state/store';
import { createTheme, type Language } from './src/styles/theme';
import LocaleBase from './src/templates/LocaleBase';

interface LocalePageContext {
	language?: Language;
	i18n?: {
		language?: Language;
	};
}

type LocalePageElementArgs = WrapPageElementBrowserArgs<Record<string, never>, LocalePageContext>;

const getLanguage = (props: LocalePageElementArgs['props']) => props.pageContext.i18n?.language ?? props.pageContext.language;

export const onClientEntry = () => {
	//기본 url에 물린 session 쿠키 제거, 로컬 제외.
	if (window.location.hostname !== 'localhost') {
		Cookies.remove('session');
		process.env.GATSBY_COOKIE_HOST !== window.location.host && Cookies.remove('session', { domain: window.location.host });
	}

	void initChannelIO();
};

export const onInitialClientRender = () => {
	// Rehydrating Zustand changes components that Gatsby is still hydrating.
	// Defer it one task so the SSR tree is fully claimed before persisted state applies.
	window.setTimeout(hydrateAppStore, 0);
};

export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs) => element;

export const wrapPageElement = ({ element, props }: LocalePageElementArgs) => {
	const language = getLanguage(props);

	return (
		<ThemeProvider theme={createTheme(language)}>
			<LocaleBase language={language}>{element}</LocaleBase>
		</ThemeProvider>
	);
};
